import React from 'react';

const AuthBanner = () => {
  return (
    <div className='auth-banner-container'>
      <h1 className='auth-banner-title container'>Sakeenat Ibadurahma Institue</h1>
    </div>
  );
};

export default AuthBanner;
